<template>
    <div class="wrapper">
        <!-- <div class="isDisable"></div> -->
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="alert alert-warning" role="alert">
                        Complete Your Transaction!
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <figure>
                                        <img :src="robot.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8">
                                    <h3 class="fw-bold">{{robot.name}}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="robot.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                <span v-else-if="robot.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="robot.risk_level == 1" class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="robot.trade_report_file" target="_blank">
                                                    <i class="fas fa-file" v-if="robot.trade_report_file !== null"></i><span v-else>-</span>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Strategy</p>
                                            <p class="text" v-html="robot.strategy ? robot.strategy : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Description</p>
                                            <p class="text" v-html="robot.description ? robot.description: '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Type</p>
                                            <p class="text">
                                                {{robot.type ? robot.type : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Lot Size</p>
                                            <p>
                                                <span class="badge bg-dark me-1">{{pairSelection.lot_sizes ? pairSelection.lot_sizes : '-'}}</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Active Pair</p>
                                            <p class="text">
                                                {{pairSelection.active_pairs ? pairSelection.active_pairs : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Pair Option</p>
                                            <p>
                                                <span v-for="(pair, index) in pairSelection.pair_options" :key="index" class="badge bg-dark me-1">{{pair ? pair : '-'}}</span>
                                            </p>
                                        </div>
                                         <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Price</p>
                                            <p class="text" v-if="robot.selling_price">
                                                Rp {{new Intl.NumberFormat('id-ID').format(Number(parseInt(robot.selling_price)).toFixed())}}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!robot.selling_price">
                                               Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Artkey Price</p>
                                            <p class="text" v-if="artKey">
                                                Rp {{new Intl.NumberFormat('id-ID').format(Number(parseInt(artKey)).toFixed())}}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!artKey">
                                                Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{robot.updated_at | moment}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="broker">
                                        <p class="text-muted m-0">Broker :</p>
                                        <img :src="broker.logo" class="broker_img" alt="">
                                        <h5 class="mb-3 fw-bold">{{broker.name}}</h5>

                                        <div class="step">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h5>You're almost there! Here's how you can activate your robot:</h5>
                                                    <div class="timeline">
                                                        <!-- <div>
                                                            <div class="bullet bg-red">
                                                                1
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">Choose a robot.</h3>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                2
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">Set a broker account for your robot.</h3>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                3
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">Set your deposit amount.</h3>
                                                            </div>
                                                        </div> -->
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                1
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">
                                                                Make a deposit on your broker account. Visit 
                                                                <a href="#" @click="goToBrokerPortal()">here</a> 
                                                                if you haven't</h3>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                2
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">Click the <strong>Checkout Order</strong> button below and complete the payment of your order.</h3>
                                                            <!-- <h3 class="timeline-header no-border">Go into <strong>My Subscriptions</strong>, and complete the payment of your order.</h3> -->
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                3
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">Activate robot using a private key provided exclusively for you. This key will be directly sent via email, please check it regularly.</h3>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="bullet bg-red">
                                                                4
                                                            </div>
                                                            <div class="timeline-item">
                                                            <h3 class="timeline-header no-border">You are all set. Your trade will begin shortly.</h3>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <blockquote>
                                                <h5>Cara Aktivasi Broker :</h5>
                                                <ul>
                                                    <li>1. Step nomor 1</li>
                                                    <li>2. Step nomor 2</li>
                                                    <li>3. Step nomor 3</li>
                                                </ul>
                                            </blockquote> -->
                                        </div>
                                    </div>

                                    <button type="button" @click="goToPayment()" class="btn btn_red to_deposit d-flex align-items-center justify-content-center" :disabled="loading">
                                        <span v-if="loading" class="spinner-border text-light spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Continue to payment
                                    </button>

                                    <!-- <div class="modal fade" id="chooseBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <div class="text-center">
                                                        <h3 class="title">{{brokerName}}</h3>
                                                        <p>Are you sure to choose this Broker?</p>
                                                    </div>

                                                    <form @submit.prevent="handleProduct()">
                                                        <input type="hidden" v-model="product.investor_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.broker_account_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.payment_amount" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.currency" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.status" class="form-control" readonly >
                                                        <div class="row">
                                                            <div class="col-lg-6 mx-auto">
                                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal">No</button>
                                                                    <button type="submit" class="btn btn_red">Yes, I'm sure</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <dash-footer></dash-footer> -->
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
// import $ from 'jquery'
import moment from "moment";

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            robot: [],
            broker:[],
            details:[],
            pairSelection: {
                active_pairs: '',
                lot_sizes: '',
                pair_options: [],
            },
            brokerName: '',
            artKey: '',
            transaction: [],
            product: {
                investor_id : '',
                broker_choice : '',
                product_id : '',
                product_type : '',
                payment_amount : '',
                currency : '',
                status : '',
            }
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        
        await axios.get(`investor/robot/${this.$route.params.id}`)
        .then(response => {
            // console.log('Robot All: ', response.data.data)
            this.robot = response.data.data
        }).catch(() => {
            // console.log('Error Robot: ', err.response)
        })
        await axios.get(`artkey/price/`)
        .then(response => {
            this.artKey = response.data.data.selling_price
        }).catch(() => {
            // console.log('Error Robot: ', err.response)
        })
        this.details = this.robot.strategy.split(';');
        
        await axios.get(`investor/robot/${this.$route.params.id}/brokerchoice`)
        .then(response => {
            var brokers = response.data.data
            // console.log('Robot Broker: ', response.data.data)
            for (let i = 0; i < brokers.length; i++) {
                if (brokers[i].id == this.$route.params.broker_id) {
                    this.broker = brokers[i]
                    // console.log("Broker : ", this.broker)
                }
            }
        }).catch(() => {
            // console.log('Error broker: ', err.response)
        })

        // function to get the Options Selection from storage
        this.getOptionsSelection()
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    methods: {
        sendBroker(broker){
            this.brokerName = broker.name
        },
        getOptionsSelection(){
            const lotSize = localStorage.getItem('lotSize');
            const storedActivePair = localStorage.getItem('activePair');
        
            // store the pair options data in array
            let localVar = localStorage.getItem('pairOption').replace(/[()]/g, '')
            let arr = localVar.split(', ').map(item => item.trim());

            this.pairSelection.pair_options = arr;
            this.pairSelection.lot_sizes = lotSize;
            this.pairSelection.active_pairs = storedActivePair;

        },
        handleProduct(){
            let data = new FormData()
            data.append('investor_id', this.user_id)
            data.append('broker_choice', this.broker.id)
            // data.append('broker_account_id', this.broker.id)
            data.append('product_id', this.robot.id)
            data.append('product_type', 'ROBOT')

            // axios.put(`transaction/${localStorage.transaction_id}/`, data)
            axios.put(`investor/transaction/${localStorage.transaction_id}/broker-choice/`, data)
            .then(() => {
                // console.log(response);
                // $('#chooseBroker').modal('hide')
                window.open('https://bithouse.id', '_blank')
                this.$router.push('/subscriptions')
            }).catch(() => {
                // console.log(err.response);
            })
        },

        async getTransaction(){
            await axios.get(`investor/${localStorage.getItem('user_id')}/transaction/${localStorage.getItem('transaction_id')}/`)
            // await axios.get(`transaction/${this.$route.params.id}/?investor=${localStorage.getItem('user_id')}`)
            .then(() => {
                // let trans = response.data.data
                // console.log('Transaction Data: ', trans);
                this.handlePayment()
                // window.open(trans.payment_url, '_blank')
                // this.$router.push(`/payment/${trans.id}`)
            }).catch(() => {
                // console.log('Error Transaction: ', err.response)
            })
        },

        async handlePayment(){
            this.loading = true
            let data = new FormData()
            data.append('transaction_id', localStorage.getItem('transaction_id'))
            // data.append('broker_account_id', this.broker.id)

            await axios.post(`investor/${localStorage.user_id}/transaction/${localStorage.getItem('transaction_id')}/payment/`, data)
            .then((response) => {
                // console.log(response);
                this.loading = false
                window.open(response.data.data.payment_url, '_blank')
                this.$router.push(`/payment/${localStorage.getItem('transaction_id')}`)
            }).catch((err) => {
                this.loading = false
                this.message = err.data
                // console.log(err.response);
            })
        },

        goOut(){
            this.handlePayment()
            // window.open('https://bithouse.id', '_blank')
            // this.$router.push('/subscriptions')
        },

        goToPayment(){
            
            localStorage.removeItem('lotSize')
            localStorage.removeItem('activePair')
            localStorage.removeItem('pairOption')
            
            this.$router.push(`/payment/${localStorage.getItem('transaction_id')}`)
        },

        goToBrokerPortal(){
            let portalConfig = this.broker.configurations.filter(function(cfg){
                return cfg.name == "PORTAL"
            })

            if(portalConfig.length > 0) {
                var brokerPortalPath = portalConfig[0].endpoint
                window.open(brokerPortalPath, '_blank')
            }
        }
    }
}
</script>
<style scoped>
.data-item {
    box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
    border-radius: 0.25rem;
    background-color: #fff;
    color: #495057;
    margin-right: 15px;
    margin-top: 0;
    padding: 0;
    position: relative;
}
.data-item .timeline-header{
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    color: #495057;
    font-size: 16px;
    line-height: 1.1;
    padding: 10px;
}
</style>
<style>
.content-wrapper{
    background: transparent !important;
}
.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}

.timeline{
}
.timeline .bullet{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    top: 4px;
    left: 22px;
    box-shadow: 0 0 1px 4px rgba(237, 28, 36, 0.5);
}

.broker .broker_img{
    height: 100px;
    width: auto;
}
.broker .broker-list{
    text-decoration: none;
    color: var(--dark-grey);
}
.broker a.broker-list:hover > .broker-body{
    border: 1px solid var(--red);
}
.broker .broker-list .broker-body{
    border: 1px solid rgb(168, 168, 168);
    background: white;
    padding: 10px;
    transition: all 0.3s ease;
}
.broker .broker-list .broker-body figure{
    width: 100%;
    height: 80px;
}
.broker .broker-list .broker-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>